var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('Hero',{attrs:{"size":_vm.size,"title":_vm.title,"subtitle":_vm.subtitle}}),_c('Logos'),_c('Featured'),_c('Team')],1)}
var staticRenderFns = []

export { render, staticRenderFns }